import { to } from "react-lib/utils";
import BaseService from "react-lib/apis/services/BaseService";
import config from "config/config";

type Request = {
  apiToken?: any;
  params?: Record<string, any>;
  extra?: { division?: any; device?: any };
};

const request = async (
  method: "get" | "options" | "delete",
  path: string,
  { apiToken, extra, params }: Request
) => {
  const base = new BaseService();
  if (apiToken) base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
  if (extra?.division) base.client.defaults.headers.common["division"] = extra.division;
  if (extra?.device) base.client.defaults.headers.common["device"] = extra.device;
  const result = await to(
    base.client[method](`${config.API_HOST}${path}`, { ...extra, ...(params && { params }) })
      .then(base.handleResponse)
      .catch(base.throwErrorMessage)
  );
  return [result[1], result[0], result[2]];
};

const requestOptions = (path: string, args: Request) => request("options", path, args);

const serviceCatalogApi = {
  deletePricing: ({ pk, ...args }: Request & { pk: any }) =>
    request("delete", `/apis/BIL/pricing/${pk}/`, args),
  listOrgans: (args: Request) => request("get", "/apis/LAB/organ/", args),
  listDrugTypes: (args: Request) => request("get", "/apis/TPD/drug-type/", args),
  listSpecialLabels: (args: Request) => request("get", "/apis/TPD/special-label/", args),
  kindOptions: ({ kind, ...request }: Request & { kind: string }) =>
    requestOptions(`/apis/core/product/service/${kind}/`, request),
  serviceOptions: (request: Request) => requestOptions("/apis/core/product/service/", request),
  pricingOptions: (request: Request) => requestOptions("/apis/BIL/pricing/", request),
};

export default serviceCatalogApi;
